"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.velodrome = void 0;
exports.velodrome = {
    router: '0xa132DAB612dB5cB9fC9Ac426A0Cc215A3423F9c9',
    voter: '0x09236cfF45047DBee6B921e00704bed6D6B8Cf7e',
    bifiOpLp: '0x81f638E5d063618Fc5f6a976E48e9B803b3240C0',
};
